import React, { useState, useEffect, useRef } from "react";
import { LayoutMain } from "../LayoutMain";
import moment from "moment";
import { getWeeklyCalendar } from "../Services/AgendaServices";
import { notification } from "antd";

export const AgendaSemana = () => {
  const [idNegocio] = useState(JSON.parse(localStorage.getItem("auth")).id);
  const [currentDate, setCurrentDate] = useState(new Date()); // 9 de Octubre 2026
  const monthNames = [
    "Enero",
    "Febrero",
    "Marzo",
    "Abril",
    "Mayo",
    "Junio",
    "Julio",
    "Agosto",
    "Septiembre",
    "Octubre",
    "Noviembre",
    "Diciembre",
  ];
  const [dataAppointments, setDataAppointments] = useState([]);
  const [api, contextHolder] = notification.useNotification();
  const [disabled, setDisabled] = useState(false);

  const initialized = useRef(false);

  const errorNotificaction = (title, msj) => {
    api.error({
      title: title,
      description: msj,
      duration: 5,
      styles: { root: { backgroundColor: "#FFE4E0" } },
      showProgress: true,
    });
  };

  // Obtener el inicio de la semana (Lunes)
  const getStartOfWeek = (date) => {
    const d = new Date(date);
    const day = d.getDay();
    const diff = d.getDate() - day + (day === 0 ? -6 : 1); // Ajustar si es domingo
    return new Date(d.setDate(diff));
  };

  const startOfWeek = getStartOfWeek(currentDate);

  // Generar los 7 días de la semana
  const weekDays = Array.from({ length: 7 }).map((_, index) => {
    const day = new Date(startOfWeek);
    day.setDate(startOfWeek.getDate() + index);
    return day;
  });

  // Funciones de navegación
  const handlePrevWeek = () => {
    const newDate = new Date(currentDate);
    newDate.setDate(currentDate.getDate() - 7);
    setCurrentDate(newDate);
    setDisabled(true);
    setTimeout(() => {
      loadDataCalendar(-7);
    }, [600]);
  };

  const handleNextWeek = () => {
    const newDate = new Date(currentDate);
    newDate.setDate(currentDate.getDate() + 7);
    setCurrentDate(newDate);
    setDisabled(true);
    setTimeout(() => {
      loadDataCalendar(7);
    }, [600]);
  };

  const handleMonthChange = (e) => {
    const [year, month] = e.target.value.split("-");
    setCurrentDate(new Date(year, month, 1));
  };

  // Formato para comparar con las citas (YYYY-MM-DD)
  const formatDateString = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  // Colores según el tipo de cita
  const getBadgeColor = (type) => {
    switch (type) {
      case "Agendada":
        return "bg-yellow-100 text-black-800 border-yellow-200";
      case "Confirmada":
        return "bg-cyan-100 text-black-800 border-cyan-200";
      case "Realizada":
        return "bg-blue-100 text-blue-800 border-blue-200";
      case "Completada":
        return "bg-emerald-100 text-emerald-800 border-emerald-200";
      case "Personal":
        return "bg-purple-100 text-purple-800 border-purple-200";
      default:
        return "bg-gray-100 text-gray-800 border-gray-200";
    }
  };

  const loadDataCalendar = async (cambioSem) => {
    const data = {
      id: idNegocio,
      weekDays: weekDays,
      cambioSem: cambioSem,
    };

    await getWeeklyCalendar(data)
      .then((res) => {
        setDataAppointments(res.data);
        setDisabled(false);
      })
      .catch((error) => {
        if (error.status === 401) {
          errorNotificaction(
            "Inicio de sesión",
            "Debe iniciar sesión, antes de continuar...",
          );
          setTimeout(() => {
            window.location = `/`;
          }, 1200);
        } else {
          setDisabled(false);
          errorNotificaction("error", error.message);
        }
      });
  };

  useEffect(() => {
    loadDataCalendar(0);
  }, []);

  useEffect(() => {}, [weekDays]);

  return (
    <div>
      <title>Agenda Semanal</title>
      <LayoutMain titleItem={"AgendaSemana"}>
        {contextHolder}
        <div className="mx-auto p-6 bg-white rounded-2xl shadow-lg border border-gray-100">
          {/* Cabecera y Controles */}
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4 mb-6 pb-4 border-b border-gray-100">
            <div>
              <h2 className="text-2xl font-bold text-gray-800">
                {monthNames[currentDate.getMonth()]} {currentDate.getFullYear()}
              </h2>
              <p className="text-sm text-gray-500 uppercase">
                Vista de agenda semanal
              </p>
            </div>

            <div className="flex items-center gap-3">
              {/* Selector rápido de Mes/Año */}
              <input
                type="month"
                value={`${currentDate.getFullYear()}-${String(currentDate.getMonth() + 1).padStart(2, "0")}`}
                onChange={handleMonthChange}
                className="px-3 py-2 border border-gray-300 rounded-lg text-sm text-gray-700 bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500"
              />

              {/* Botones Semana Anterior / Siguiente */}
              <div className="flex items-center bg-gray-100 p-1 rounded-lg">
                <button
                  onClick={handlePrevWeek}
                  className="px-3 py-1.5 text-sm font-medium text-gray-700 hover:bg-white rounded-md transition shadow-sm"
                  disabled={disabled}
                >
                  Anterior
                </button>
                <button
                  onClick={handleNextWeek}
                  className="px-3 py-1.5 text-sm font-medium text-gray-700 hover:bg-white rounded-md transition shadow-sm"
                  disabled={disabled}
                >
                  Siguiente
                </button>
              </div>
            </div>
          </div>

          {/* Grid de la Semana */}
          <div className="grid grid-cols-1 md:grid-cols-7 gap-3">
            {weekDays.map((day, index) => {
              const dateStr = formatDateString(day);
              const dayAppointments = dataAppointments.filter(
                (app) => app.fecha === dateStr,
              );
              const isToday = formatDateString(new Date()) === dateStr;

              return (
                <div
                  key={index}
                  className={`flex flex-col p-3 rounded-xl border transition-all min-h-[180px] ${
                    isToday
                      ? "bg-blue-50/40 border-blue-300 shadow-sm"
                      : "bg-gray-50/50 border-gray-200"
                  }`}
                >
                  {/* Día de la semana y número */}
                  <div className="flex items-center justify-between mb-3">
                    <span className="text-xs font-semibold uppercase tracking-wider text-gray-500">
                      {day.toLocaleDateString("es-ES", { weekday: "short" })}
                    </span>
                    <span
                      className={`text-sm font-bold w-7 h-7 flex items-center justify-center rounded-full ${
                        isToday ? "bg-blue-600 text-white" : "text-gray-800"
                      }`}
                    >
                      {day.getDate()}
                    </span>
                  </div>

                  {/* Contenedor de Badges / Citas */}
                  <div className="flex flex-col gap-2 flex-grow">
                    {dayAppointments.length > 0 ? (
                      dayAppointments.map((app) => (
                        <div
                          key={app.id}
                          className={`text-xs p-2 rounded-lg border flex flex-col gap-0.5 shadow-xs ${getBadgeColor(app.estado)}`}
                        >
                          <span className="text-[12px] font-bold opacity-90 text-end">
                            {app.hora.substring(0, 5)}
                          </span>
                          <span className="font-semibold">{app.paciente}</span>
                        </div>
                      ))
                    ) : (
                      <span className="text-xs text-gray-400 italic mt-4 text-center">
                        Sin citas
                      </span>
                    )}
                  </div>
                </div>
              );
            })}

            <div className="flex items-center gap-3">
              
              {/* ETIQUETA AGENDADA */}
              <div className="flex flex-col gap-3">
                <span className="text-sm font-medium text-gray-700">
                </span>
                <span className="px-3.5 py-1 text-xs font-bold rounded-full border shadow-sm bg-yellow-100 text-black-800 border-yellow-200">Agendada</span>
              </div>

              {/* ETIQUETA CONFIRMADA */}
              <div className="flex flex-col gap-3">
                <span className="text-sm font-medium text-gray-700">
                </span>
                <span className="px-3.5 py-1 text-xs font-bold rounded-full border shadow-sm bg-cyan-100 text-black-800 border-cyan-200">Confirmada</span>
              </div>

              {/* REALIZADA */}
              <div className="flex flex-col gap-3">
                <span className="text-sm font-medium text-gray-700">
                </span>
                <span className="px-3.5 py-1 text-xs font-bold rounded-full border shadow-sm bg-blue-100 text-blue-800 border-blue-200">Realizada</span>
              </div>

              {/* COMPLETADA */}
              <div className="flex flex-col gap-3">
                <span className="text-sm font-medium text-gray-700">
                </span>
                <span className="px-3.5 py-1 text-xs font-bold rounded-full border shadow-sm bg-emerald-100 text-emerald-800 border-emerald-200">Completada</span>
              </div>
            
            </div>
          </div>
        </div>
      </LayoutMain>
    </div>
  );
};
